import { DatiRichiedenteDTO } from "./dati-richiedente-dto";
import { DichiarazioneDTO } from "./dichiarazione-dto";
import { DocumentoDTO } from "./documento-dto";
import { IdentificativoRichiestaDTO } from "./identificativo-richiesta-dto";
import { RappresentanteDTO } from "./rappresentante-dto";

export class CostituzioneDepositoDTO<T> {
	codiceRTS: string;
	denominazioneRTS: string;
	dataRichiesta: Date;
	datiRichiedente: DatiRichiedenteDTO;
	datiSpecificiDeposito: T;
	metadatiDocumenti: Array<DocumentoDTO>;
	identificativoRichiesta: IdentificativoRichiestaDTO;
	rappresentanza: RappresentanteDTO;
	dichiarazioni: Array<DichiarazioneDTO>;
}